export const tasks = [
  {
    title: 'Let the creator decide',
    creatorTitle: 'Creator’s choice',
    artistDescription:
      'Creators know their audience and will choose the video style that works best.',
    creatorDescription:
      'Create the kind of video you know will make this track shine for your audience.',
    value: 'creator_decide',
  },
  {
    title: '👄 Lipsync',
    creatorTitle: '👄 Lipsync',
    artistDescription:
      'Creators act out or perform your lyrics by lip syncing to bring your track to life visually.',
    creatorDescription:
      'Lip sync the lyrics to bring the track to life visually.',
    value: 'lipsync',
  },
  {
    title: '🔁 Transition',
    creatorTitle: '🔁 Transition',
    artistDescription:
      'Creators show a visual change — like outfit, mood, or scene — timed to a key moment in your song, such as a beat drop or mood shift.',
    creatorDescription:
      'Create a before-and-after effect timed with the song — perfect for a beat drop or mood shift.',
    value: 'transition',
  },
  {
    title: '💡 POV (Point of view)',
    creatorTitle: '💡 POV (Point of view)',
    artistDescription:
      'Creators tell a story from a personal perspective that connects to your song — like a scene from their life.',
    creatorDescription:
      'Tell a story from a personal perspective that connects to the song — like a scene from real life.',
    value: 'pov',
  },
  {
    title: '🎧 First listen reaction',
    creatorTitle: '🎧 First listen reaction',
    artistDescription:
      'Creators share their genuine emotions while hearing your track for the first time.',
    creatorDescription:
      'Share your genuine emotions while hearing the track for the first time.',
    value: 'first_listen_reaction',
  },
  {
    title: '💄 Get ready with me',
    creatorTitle: '💄 Get ready with me',
    artistDescription:
      'Creators show their getting-ready process while your song plays — often featuring outfit, makeup, or vibe shifts.',
    creatorDescription:
      'Show a before-and-after change — like outfit, mood, or scene — timed to a key moment in the track (like a beat drop or mood change).',
    value: 'get_ready_with_me',
  },
]
